// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__kNGYu","col":"styles_col__Mgm6S"};